<template>
    <div class="bg">
        <div v-if="sta.accounttype!==2 && sta.accounttype!==3 && sta.accounttype!==5">
            <div class="title">众智云擎，税收法规查询及云端工作系统</div>
            <swiper  id="newstorecontainer" ref="mySwiper" :options="swiperOptions">
                <swiper-slide style="width:150px;" v-for="product in productlist" :key="product.code">
                    <div class="e">
                        <div style="background: linear-gradient(90deg, #FFECD8 0%, #FAE3C4 100%);">
                            <h2>
                            <img v-if="product.name.indexOf('专业')>-1" src="../../assets/images/img/user_pro.png" height="25" style="position: relative;top:3px;">
                            <img v-else-if="product.name==='体验版'" src="../../assets/images/img/user_trial.png" height="25" style="position: relative;top:3px;">
                            <span v-else></span>
                            {{product.name}}</h2>
                            <h1 style="height: 90px;">
                                <div v-if="sta.accounttype===2"></div>
                                <div v-else><span class="symbol">¥</span>{{product.price}} <span class="year"></span></div>
                            </h1>
                        </div>
                        <div v-if="product.warntext!==''">{{product.warntext}}</div>
                        <div class="btn">
                            <div style="font-size: 18px;color:#19be6b;" v-show="product.name==='体验版'?true:false">体验版</div>
                            <Button v-show="product.showbuybtn" type="error" class="innserbtn" @click="goBuy(product)">{{product.buybtntext}}</Button>
                            <Button v-show="product.showupbtn" type="success" class="innserbtn" @click="goUpgradeInfo(product)">{{product.upbtntext}}</Button>
                        </div>
                        <div class="pricedesc">{{product.desc}}</div>
                        <Divider dashed class="divider">VIP权益</Divider>
                        <!-- <div class="splitline"></div> -->
                        <div id="funclistbox">
                            <ul>
                                <li v-for="item in product.BasePackageFun">
                                    <span style="display:block;float:left;">{{item.alias}}</span>
                                    <span style="display:block;float:right;">
                                        <Icon type="md-checkmark" color="green" /></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <Spin size="large" fix v-if="showmaskboard"></Spin>
        </div>
        <div v-else>
            <img id="bground" style="display:block;margin:3% auto;" src="../../assets/images/store/contact_default.png" />
            <h2 style="text-align: center;">{{sta.accounttype==5?"您是万和众智财税企服平台用户，请联系单位管理员购买（续费）或升级":"您是定制化团购用户，请联系单位管理员购买（续费）或升级"}}</h2>
        </div>
        <Modal class="purchaseConfirm" v-model="modalConfirm" title='' width="1000px" :mask-closable="false" :footer-hide="true">
            <!-- <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <span>{{renewalType===1?'购买':(renewalType===2?'续费':'服务升级')}}</span>
            </p> -->
            <div>
                <product-confirm ref="myconfirmlist" @payComplete="payfinished" />
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="cancelPurchase">取消</Button>
                <Button type="primary" size="large">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import product_confirm from './newstore_confirm.vue'
import { mapGetters } from 'vuex'
import eventBus from "../../components/common/event_bus.js"
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            showmaskboard:true,
            renewalType: 1,
            modalConfirm: false,
            productlist: [],
            swiperOptions: {
                simulateTouch: false,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                slidesPerView: 'auto',
                centerInsufficientSlides: true,
                spaceBetween: 20,
                disabledClass: 'my-button-disabled',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                // pagination: {
                //     el: '.swiper-pagination',
                //     type: 'fraction',
                // },
            },
            maxlength: 0,
        }
    },
    components: {
        'product-confirm': product_confirm,
    },
    created() {
        if (this.checkUserLogin()) {
            this.getProductsV2()
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    computed: {
        ...mapGetters(['sta']),
    },
    mounted() {

        //console.log('Current Swiper instance object', this.swiper)
        //this.swiper.slideTo(3, 1000, false)
    },
    methods: {
        //计算专业版功能长度
        heightbalance() {
            let products = this.productlist
            if (products.length > 0) {
                //let el = products.find(p => p.name === '专业版')
                let el = products.find(p => p.name === '专业版-年卡')
                this.maxlength = el.BasePackageFun.length
            }

        },
        payfinished() {
            this.modalConfirm = false
            this.getProductsV2()
            //刷新token，更新用户登录状态
            setTimeout(() => {
                eventBus.$emit('user-reload-update')
            }, 3000)
        },
        getProductsV2() {
            //store.state.user.accounttype=3
            console.log('store.state.user.accounttype' + store.state.user.accounttype)
            console.log('getProducts V2==========>')
            this.showmaskboard=true
            return new Promise((resolve, reject) => {
                constJ.reqGetProductsV2().then(res => {
                    console.log(res)
                    if (res.rltcode === 1 && res.rtncode === 1) {
                        this.productlist = res.data.products
                        //this.heightbalance()
                        resolve(res)
                        this.showmaskboard=false
                    } else {
                        this.$Message.warning(res.rtndesc)
                        return
                    }
                }).catch(function(err) {
                    reject(err)
                })
            })

        },
        goBuy(product) {
            if (product.showbuybtn) {
                if (product.buybtntext.indexOf('购买') >= 0) {
                    this.goPurchase(product)
                } else if (product.buybtntext.indexOf('续费') >= 0) {
                    this.goRenewal(product)
                }
            }
        },
        //购买
        goPurchase(product) {
            //1=购买，2=续费，3=升级
            this.renewalType = this.$Tools.getRenewType().PURCHASE
            this.$refs.myconfirmlist.show(product, this.renewalType)
            this.modalConfirm = true
        },
        //续费
        goRenewal(product) {
            this.renewalType = this.$Tools.getRenewType().RENEWAL
            this.$refs.myconfirmlist.show(product, this.renewalType)
            this.modalConfirm = true
        },
        //计算升级数据
        goUpgradeInfo(product) {
            this.renewalType = this.$Tools.getRenewType().UPDATE
            this.$refs.myconfirmlist.show(product, this.renewalType)
            this.modalConfirm = true
        },
        cancelPurchase() {
            this.modalConfirm = false
        },
        checkUserLogin() {
            let value = this.sta.userId
            if (value && value.length > 0) {
                return true
            } else {
                return false
            }
        },
    },

}
</script>
<style lang="less" scoped>
.purchaseConfirm/deep/.ivu-modal-body{
    padding:0px;
}

.bg{
    background:url('../../assets/images/store/new_store_bg.png');
    background-size:100% 100%;
}
.title {
        height: 40px;
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #17233d;
        line-height: 24px;
        text-align: center;
        padding-top:70px;
}
#newstorecontainer {
    //background-color: #f8f8f9;
    min-height: 1400px;

    height: auto;
   
    .swiper-slide {
        // min-width:20%;
        min-width: 280px;
        height: auto;
        margin-bottom: 50px;

        div {
             border-radius:15px 15px 0px 0px;
            // 标题
            h1 {
                margin-top: 20px;
                font-size: 46px;
                color:#ff3400;
                .symbol {
                    font-size: 16px;
                    vertical-align: top;
                    margin-right: 5px;
                    color: #ff3400;
                    font-weight: 400;

                }

                .year {
                    font-size: 18px;
                    font-weight: 500;
                    color: #808695;
                }
            }

            // 产品名称
            h2 {
                margin-top: 0px;
                font-weight: 500;
                font-family: Source Han Sans CN;
                color: #2D2F33;
                display: block;
                border-radius:10px;
                vertical-align: middle;
                padding-top:30px;

            }

            //产品价格说明
            .pricedesc {
                margin-top: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #17233D;
            }

            .btn {
                //margin-top: 70px;
                display: block;
                height: 60px;
                line-height: 80px;
                vertical-align: middle;

                //background-color: lightblue;
                //line-height: 50px;
                .innserbtn {
                    width: 200px;
                    height: 36px;
                }

            }


            .divider{
                height: 14px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
            }

            // .splitline {
            //     margin: 0 auto;
            //     margin-top: 20px;
            //     border-top: 1px dashed #e8eaec;
            //     width: 100%;
            //     display: block;
            // }

            //功能描述
            #funclistbox {
                margin-top: 0px;
                margin-bottom: 20px;

                ul {
                    li {
                        //list-style-type:none;
                        margin: 5px 20px;
                        line-height: 20px;
                        height: 20px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        color: #17233D;
                        font-weight: Regular;
                        display: block;
                    }
                }
            }
        }

    }
}



.rmbsymbol {
    font-size: 10px;
    vertical-align: top;
    margin-right: 5px;
}



.e {
    min-height: 600px;
    margin: 0 auto;
    display: block;
    text-align: center;
    border: 1px solid #dcdee2;
    margin-top: 80px;
    border-radius: 10px;
    animation: restorebox 0.4s;
    background:white;

}

.e:hover {
    background-color: #FFFAF6;
    min-height: 600px;
    margin: 0 auto;
    display: block;
    text-align: center;
    border: 1px solid #dcdee2;
    //margin-top: 75px;
    border-radius: 15px;
    -moz-box-shadow: 0 10px 20px rgba(16, 20, 98, 0.16);
    -webkit-box-shadow: 0 10px 20px rgba(16, 20, 98, 0.16);
    box-shadow: 0 10px 20px rgba(16, 20, 98, 0.16);
    margin-top: 60px;
    animation: activebox 0.4s;
    -moz-animation: activebox 0.4s;
    /* Firefox */
    -webkit-animation: activebox 0.4s;
    /* Safari and Chrome */
    -o-animation: activebox 0.4s;
    /* Opera */

}

@keyframes activebox {
    from {
        margin-top: 80px;
    }

    to {
        margin-top: 60px;
    }
}

@-moz-keyframes activebox

/* Firefox */
    {
    from {
        margin-top: 80px;
    }

    to {
        margin-top: 70px;
    }
}

@-webkit-keyframes activebox

/* Safari and Chrome */
    {
    from {
        margin-top: 80px;
    }

    to {
        margin-top: 70px;
    }
}

@-o-keyframes activebox

/* Opera */
    {
    from {
        margin-top: 80px;
    }

    to {
        margin-top: 70px;
    }
}


@keyframes restorebox {
    from {
        margin-top: 60px;
    }

    to {
        margin-top: 80px;
    }
}
</style>